module.exports = __webpack_public_path__ + "img/INSTAGRAM.c0352e8c.svg";